module.exports = __webpack_public_path__ + "static/media/hearclearpro-logo.8ea04837.png";